import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { Identity } from '../../../../../shared/enums';
import EmptyChatIcon from '../../../../assets/chat-icon.svg';

import BotMessage from './BotMessage';
import HumanMessage from './HumanMessage';
import DotsTyping from './DotsTyping';

import styles from '../../../styles/views/components/AIChatbot/MessageThread.module.scss';


const MessageThread = ({
  currentUser,
  messages,
  generationType,
  isAnswerLoading,
  isTranscriptIncluded,
  onHide,
  tokensMultiplier,
  messagesContainerRef,
}) => {
  useEffect(() => {
    if (!messagesContainerRef.current) return;
    messagesContainerRef.current.scrollTo(0, messagesContainerRef.current.scrollHeight);
  }, [messagesContainerRef, messages]);

  const userInitials = `${
    [currentUser.firstName, currentUser.lastName].join(' ')
      .split(' ')
      .map((item) => item[0])
      .join('')}`;


  return (!isEmpty(messages) ? (
    <div className={styles.container}>
      {messages.map(({
        id, type, messageText, question,
      }) => (
        <React.Fragment key={id}>
          {type === Identity.HUMAN && <HumanMessage message={messageText} userInitials={userInitials} />}
          {type === Identity.BOT && (
          <BotMessage
            message={messageText}
            question={question}
            generationType={generationType}
            isAnswerLoading={isAnswerLoading}
            isTranscriptIncluded={isTranscriptIncluded}
            onHide={onHide}
            tokensMultiplier={tokensMultiplier}
          />
          )}
        </React.Fragment>
      ))}
      {isAnswerLoading && <DotsTyping />}
    </div>
  ) : (
    <div className={styles.emptyList}>
      <div className={styles.iconWrapper}>
        <EmptyChatIcon />
      </div>
    </div>
  ));
};

MessageThread.propTypes = {
  messages: PropTypes.array,
  currentUser: PropTypes.object,
  generationType: PropTypes.string,
  isAnswerLoading: PropTypes.bool,
  isTranscriptIncluded: PropTypes.bool,
  onHide: PropTypes.func,
  tokensMultiplier: PropTypes.number,
  messagesContainerRef: PropTypes.object,
};

MessageThread.defaultProps = {
  currentUser: {},
  messages: [],
  generationType: '',
  isAnswerLoading: false,
  isTranscriptIncluded: true,
  onHide: () => {},
  tokensMultiplier: 1,
  messagesContainerRef: null,
};

export default MessageThread;
